/**
 *
 * 线动画
 */

export default {
  style: {
    default: {
      fill: 'red',
      r: 3
    }
  },
  delay: 3000
}
